import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
    © 2020, Powered by A F Solutions
    </span>
  `,
})
export class FooterComponent {
}
